// Funciones del modo sin conexión: descargar y leer la copia local (localforage).
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db, auth } from "@/firebase";
import { query, collection, getDocs } from "firebase/firestore";
import localforage from "localforage";
import { colecciones } from "../constantes";

export const funcionesOffline = {
  async obtenerModoSinConexion() {
    const modoSinConexion = await localforage.getItem(
      colecciones.localforage.modoSinConexion,
    );
    return modoSinConexion || !navigator.onLine ? true : false;
  },
  // DESCARGAR O BORRAR INFORMACIÓN PARA USO OFFLINE
  async descargarInformacionOffline(esDescargar) {
    if (esDescargar) {
      await this.obtenerUsuarioOffline();
      await this.obtenerDepartamentosCiudadesOffline();
      await this.obtenerTrabajadoresOffline();
      await this.obtenerConductoresOffline();
      await this.obtenerVehiculosOffline();
      await this.obtenerFormatosOffline();
      await this.obtenerLicenciasConductoresOffline();
      await this.obtenerExamenesConductoresOffline();
      await this.obtenerCapacitacionesConductoresOffline();
      await this.obtenerRevisionesConductoresOffline();
      await this.obtenerDocumentosVehiculosOffline();
      await this.obtenerRevisionesVehiculosOffline();
      await this.obtenerKilometrajesVehiculosOffline();
    } else {
      await localforage.setItem(colecciones.localforage.usuarios.local, {});
      await localforage.setItem(colecciones.localforage.departamentos, []);
      await localforage.setItem(colecciones.localforage.ciudades, []);
      await localforage.setItem(
        colecciones.localforage.empresa.trabajadores.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.formatos.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.conductores.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.vehiculos.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.vehiculos.kilometrajes
          .registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.vehiculos.documentos.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.vehiculos.revisiones.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.conductores.licencias.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.conductores.examenes.registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.conductores.capacitaciones
          .registros,
        [],
      );
      await localforage.setItem(
        colecciones.localforage.seguridadVial.conductores.revisiones
          .registros,
        [],
      );
    }
  },
  // OBTENER USUARIO PARA USUARIO OFFLINE
  async obtenerUsuarioOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuarioActual = await this.obtenerUsuario(auth.currentUser.uid);
      delete usuarioActual.correo;
      delete usuarioActual.password;
      await localforage.setItem(
        colecciones.localforage.usuarios.local,
        usuarioActual,
      );
    }
  },
  // OBTENER DEPARTAMENTOS Y CIUDADES PARA USO OFFLINE
  async obtenerDepartamentosCiudadesOffline() {
    if (navigator.onLine && auth.currentUser) {
      // OBTENER DEPARTAMENTOS
      const q = query(collection(db, "paises/Colombia/departamentos"));
      const querySnapshot = await getDocs(q);
      const departamentos = querySnapshot.docs.map((doc, index) => {
        return {
          id: index + 1,
          nombre: doc.id,
        };
      });
      await localforage.setItem(
        colecciones.localforage.departamentos,
        departamentos,
      );

      // OBTENER CIUDADES
      const registros = await Promise.all(
        departamentos.map(async (item) => {
          const q = query(
            collection(
              db,
              "paises/Colombia/departamentos/" + item.nombre + "/municipios",
            ),
          );
          const querySnapshot = await getDocs(q);
          return querySnapshot.docs.map((doc, index) => {
            return {
              id: index + 1,
              idDepartamento: item.id,
              token: `${item.nombre}_${doc.id}`,
              nombre: doc.id,
            };
          });
        }),
      );
      const ciudades = registros.flatMap((item) => item);
      await localforage.setItem(colecciones.localforage.ciudades, ciudades);
    }
  },
  // OBTENER TRABAJADORES PARA USO OFFLINE
  async obtenerTrabajadoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const trabajadoresActuales = await this.obtenerTrabajadores(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.empresa.trabajadores.registros,
          trabajadoresActuales,
        );
      }
    }
  },
  // OBTENER FORMATOS PARA USO OFFLINE
  async obtenerFormatosOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const formatosActuales = await this.obtenerFormatos(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.formatos.registros,
          formatosActuales,
        );
      }
    }
  },
  // OBTENER CONDUCTORES PARA USO OFFLINE
  async obtenerConductoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const conductoresActuales = await this.obtenerConductores(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.conductores.registros,
          conductoresActuales,
        );
      }
    }
  },
  // OBTENER VEHICULOS PARA USO OFFLINE
  async obtenerVehiculosOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const vehiculosActuales = await this.obtenerVehiculos(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.vehiculos.registros,
          vehiculosActuales,
        );
      }
    }
  },
  // OBTENER ULTIMOS KILOMETRAJES DE VEHICULOS PARA USO OFFLINE
  async obtenerKilometrajesVehiculosOffline() {
    if (navigator.onLine && auth.currentUser) {
      let vehiculos = await localforage.getItem(
        colecciones.localforage.seguridadVial.vehiculos.registros,
      );
      if (!vehiculos || vehiculos.length === 0) {
        const usuario = auth.currentUser;
        const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
        if (
          obtenerUsuario &&
          obtenerUsuario.preferencias.idEmpresaSeleccionada
        ) {
          vehiculos = await this.obtenerVehiculos(
            obtenerUsuario.preferencias.idEmpresaSeleccionada,
          );
        }
      }
      if (vehiculos && vehiculos.length > 0) {
        const registros = await Promise.all(
          vehiculos.map(async (vehiculo) => {
            return await this.obtenerUltimoKilometrajeVehiculo(vehiculo.id);
          }),
        );
        const kilometrajes = registros.filter((item) => item !== null);
        await localforage.setItem(
          colecciones.localforage.seguridadVial.vehiculos.kilometrajes
            .registros,
          kilometrajes,
        );
      }
    }
  },
  // OBTENER DOCUMENTOS DE VEHICULOS PARA USO OFFLINE
  // DOCUMENTOS
  async obtenerDocumentosVehiculosOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const documentosActuales = await this.obtenerDocumentosVehiculos(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.vehiculos.documentos
            .registros,
          documentosActuales,
        );
      }
    }
  },
  // REVISIONES
  async obtenerRevisionesVehiculosOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const revisionesActuales = await this.obtenerRevisionesVehiculos(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.vehiculos.revisiones
            .registros,
          revisionesActuales,
        );
      }
    }
  },
  // OBTENER DOCUMENTOS DE CONDUCTORES PARA USO OFFLINE
  // LICENCIAS
  async obtenerLicenciasConductoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const licenciasActuales = await this.obtenerLicenciasConductores(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.conductores.licencias
            .registros,
          licenciasActuales,
        );
      }
    }
  },
  // EXAMENES
  async obtenerExamenesConductoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const examenesActuales = await this.obtenerExamenesConductores(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.conductores.examenes
            .registros,
          examenesActuales,
        );
      }
    }
  },
  // CAPACITACIONES
  async obtenerCapacitacionesConductoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const capacitacionesActuales =
          await this.obtenerCapacitacionesConductores(
            obtenerUsuario.preferencias.idEmpresaSeleccionada,
          );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.conductores.capacitaciones
            .registros,
          capacitacionesActuales,
        );
      }
    }
  },
  // REVISIONES DE COMPARENDOS
  async obtenerRevisionesConductoresOffline() {
    if (navigator.onLine && auth.currentUser) {
      const usuario = auth.currentUser;
      const obtenerUsuario = await this.obtenerUsuario(usuario.uid);
      if (
        obtenerUsuario &&
        obtenerUsuario.preferencias.idEmpresaSeleccionada
      ) {
        const revisionesActuales = await this.obtenerRevisionesConductores(
          obtenerUsuario.preferencias.idEmpresaSeleccionada,
        );
        await localforage.setItem(
          colecciones.localforage.seguridadVial.conductores.revisiones
            .registros,
          revisionesActuales,
        );
      }
    }
  },
  // OBTENER DEPARTAMENTOS
  async obtenerDepartamentos(pais, modoSinConexion) {
    if (modoSinConexion) {
      const departamentos = await localforage.getItem(
        colecciones.localforage.departamentos,
      );
      return departamentos ? departamentos.map((item) => item.nombre) : null;
    } else {
      const q = query(collection(db, `paises/${pais}/departamentos`));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs.map((doc) => doc.id)
        : [];
    }
  },
  // OBTENER CIUDADES
  async obtenerCiudades(pais, departamento, modoSinConexion) {
    if (modoSinConexion) {
      const departamentos = await localforage.getItem(
        colecciones.localforage.departamentos,
      );
      const ciudades = await localforage.getItem(
        colecciones.localforage.ciudades,
      );
      const departamentoTemp = departamentos.find(
        (item) => item.nombre === departamento,
      );
      const ciudadesDepartamento =
        departamentos && ciudades
          ? ciudades
            .filter((item) => item.idDepartamento === departamentoTemp.id)
            .map((item) => item.nombre)
          : [];
      return ciudadesDepartamento ? ciudadesDepartamento : [];
    } else {
      const q = query(
        collection(
          db,
          `paises/${pais}/departamentos/${departamento}/municipios`,
        ),
      );
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.length > 0
        ? querySnapshot.docs.map((doc) => doc.id)
        : null;
    }
  },
};
